var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgName(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.04718 20.375C2.70394 17.6116 6.33503 15.7202 12 15.7202C17.665 15.7202 21.2961 17.6116 22.9529 20.375M16.5 6.125C16.5 8.61028 14.4853 10.625 12 10.625C9.51474 10.625 7.50002 8.61028 7.50002 6.125C7.50002 3.63972 9.51474 1.625 12 1.625C14.4853 1.625 16.5 3.63972 16.5 6.125Z",
    stroke: "#84BE42",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgName);
export default __webpack_public_path__ + "static/media/name.cfcea35d88f6a5aef04ad78c042f9860.svg";
export { ForwardRef as ReactComponent };